import React,{ useState } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './style/index.scss';


import "core-js/stable";
import "regenerator-runtime/runtime";

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

require('es6-object-assign').polyfill();

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);